(function() {
    'use strict';
    angular
        .module('MW.ContactManager.ContactManagerOutreachComposeController', [
            'MW.Framework.TranslationService',
            'ngTagsInput',
            'MW.Framework.ContentStreamDataFactory',
            'MW.ContactManager.OutreachService',
            'MW.Influencers.IcmUnsubscribeService',
            'MW.Framework.TextFilters',
            'MW.CoreStream.ContactManagerTagService',
            'MW.Framework.FileModel',
            'MW.Influencers.IcmDialogService',
            'ngSanitize',
            'MW.Framework.ICMEmailService',
            'MW.Framework.FileUploadSelector',
            'MW.ContactManager.ContactManagerNavigationService',
            'MW.Influencers.AnalyticsService',
            'MW.Framework.CoreUserService',
            'MW.Framework.CoreCompanyService',
            'MW.ContactManager.ContactAutocompleteFilter',
            'MW.Framework.InfluencerContactService',
            'MW.Framework.ValidationConstants',
            'MW.Framework.EntitlementService',
            'ngRoute',
            'Configuration',
            'MW.Influencers.DateTimePicker',
            'MW.Framework.EntitlementService',
            'MW.ContactManager.MwOutreachPreviewModal',
            'MW.Influencers.OutreachBannerService',
            'MW.Influencers.EmailTemplateService',
            'MW.Framework.ICMUserService',
            'MW.Influencers.ManifestService',
            'MW.Influencers.MrCompanyService'
        ])
        .controller('ContactManagerOutreachComposeController', [
            '$scope',
            '$timeout',
            '$translate',
            'translationService',
            'ContactStreamDataFactory',
            'OutreachService',
            'IcmUnsubscribeService',
            'ContactManagerTagService',
            'DialogService',
            '$sanitize',
            'ICMEmailService',
            '$location',
            '$window',
            'ContactManagerNavigationService',
            '$filter',
            '$q',
            '$mdDialog',
            'editorLanguage',
            'approvedSenderArray',
            'dialogMode',
            'DEFAULT_MEDIA_LIST',
            'FILE_UPLOADER_URL',
            '$routeParams',
            'AnalyticsService',
            'CoreUserService',
            'CoreCompanyService',
            'InfluencerContactService',
            'moment',
            'MOMENT_MEDIUM_DATE',
            'VALIDATION_CONSTANTS',
            'EntitlementService',
            'ICM_RECIPIENTS_PER_DISTRIBUTION',
            'ICM_RECIPIENTS_PER_DAY',
            'ICM_ASSETS_URL',
            'IRM_BASE_URL',
            'ICM_BASE_URL',
            'OutreachBannerService',
            'sendgridDomainsArray',
            'EmailTemplateService',
            'templatesList',
            'ICMUserService',
            'ManifestService',
            'MrCompanyService',
            '$sce',
            ContactManagerOutreachComposeController
        ]);

    function ContactManagerOutreachComposeController(
        $scope,
        $timeout,
        $translate,
        translationService,
        ContactStreamDataFactory,
        OutreachService,
        IcmUnsubscribeService,
        ContactManagerTagService,
        DialogService,
        $sanitize,
        ICMEmailService,
        $location,
        $window,
        ContactManagerNavigationService,
        $filter,
        $q,
        $mdDialog,
        editorLanguage,
        approvedSenderArray,
        dialogMode,
        DEFAULT_MEDIA_LIST,
        FILE_UPLOADER_URL,
        $routeParams,
        AnalyticsService,
        CoreUserService,
        CoreCompanyService,
        InfluencerContactService,
        moment,
        MOMENT_MEDIUM_DATE,
        VALIDATION_CONSTANTS,
        EntitlementService,
        ICM_RECIPIENTS_PER_DISTRIBUTION,
        ICM_RECIPIENTS_PER_DAY,
        ICM_ASSETS_URL,
        IRM_BASE_URL,
        ICM_BASE_URL,
        OutreachBannerService,
        sendgridDomainsArray,
        EmailTemplateService,
        templatesList,
        ICMUserService,
        ManifestService,
        MrCompanyService,
        $sce
    )
    {

        var toolbarButtons,
            dailyLimitErrorMessage = 'You cannot send to more than [[limits]] recipients in a 24 hour period. Reduce the number of recipients or send this email on a later date.';

        this.$sce = $sce;
        this.ManifestService = ManifestService;
        this.MrCompanyService = MrCompanyService;
        this.outreachComposeFormTemplate = 'icm-web/views/partials/outreach_compose_form';
        this.previousPage = ContactManagerNavigationService.getPreviousLocation();
        this.$q = $q;
        this.DialogService = DialogService;
        this.$timeout = $timeout;
        this.$translate = $translate;
        this.$scope = $scope;
        this.$mdDialog = $mdDialog;
        this.MOMENT_MEDIUM_DATE = MOMENT_MEDIUM_DATE;
        this.DEFAULT_MEDIA_LIST = DEFAULT_MEDIA_LIST;
        this.ICM_ASSETS_URL = ICM_ASSETS_URL;
        this.IRM_BASE_URL = IRM_BASE_URL;
        this.ICM_BASE_URL = ICM_BASE_URL;
        this.moment = moment;
        this.$sanitize = $sanitize;
        this.perDayLimitExceeded = false;
        this.perScheduledDayLimitExceeded = false;
        this.ContactStreamDataFactory = new ContactStreamDataFactory();
        this.OutreachService = OutreachService;
        this.UnsubscribeService = IcmUnsubscribeService;
        this.CoreUserService = CoreUserService;
        this.ICMUserService = ICMUserService;
        this.pendingQueryTimeout = null;
        this.ContactManagerTagService = ContactManagerTagService;
        this.translationService = translationService;
        this.CoreCompanyService = CoreCompanyService;
        this.AnalyticsService = AnalyticsService;
        this.InfluencerContactService = InfluencerContactService;
        this.ICMEmailService = ICMEmailService;
        this.$location = $location;
        this.$window = $window;
        this.editorLanguage = editorLanguage;
        this.dialogMode = dialogMode;
        this.OutreachBannerService = OutreachBannerService;
        this.sendgridDomainsArray = sendgridDomainsArray;
        this.EmailTemplateService = EmailTemplateService;
        this.messageBodyText = '';
        this.selectedContactListModel = [];
        this.selectedContactMailObj = {};
        this.contactListArray = [];
        this.mediaListArray = [];
        this.newTagModel = '';
        this.showDropDown = false;
        this.clickSelect = false;
        this.enableDuplicates = true;
        this.customTagCss = 'customEmailTag';
        this.tagCustomClassApply = [];
        this.tagEmailArray = [];
        this.contactMailArray = [];
        this.mediaListMailArray = [];
        this.subject = '';
        this.modified = null;
        this.composeFormError = false;
        this.isComposeValid = false;
        this.attachment = undefined;
        this.fileUploadList = [];
        this.formHolder = {
            composeForm: {}
        };
        this.attachments = [];
        this.totalFileAttachedSize = 0;
        this.totalFileSizeLimit = 10485760; //10 MB in bytes
        this.cachedMediaLists = {};
        this.attachmentError = {
            errorState: false,
            invalidFileType: false,
            zeroFileSize: false,
            invalidFileSize: false,
            invalidTotalFileSize: false
        };
        this.attachmentContentConfig = {
            fileInputClass: 'fileInputClass_outreach'
        };
        this.composeStep = true;
        this.schedulingOption = 'SAVE_DRAFT';
        this.userTimeZone = this.ICMUserService.getTimezoneName();
        this.userTimezoneString = this.ICMUserService.getTimezone();
        this.showDateTimePicker = false;
        this.dailyLimitForDateReached = false;
        this.defaultTimeoutForFlashMessage = 5;
        this.currentFlashInfoIndex = null;
        this.$routeParams = $routeParams;
        this.scheduledDateModel = null;
        this.dateTimeFormat = {
            dateFormat: 'M d, yy',
            timeFormat: 'HH:mm',
            momentDateFormat: 'll' // this is format used by moment which is equivalent to Datepicker(M d, yy) format
        };
        this.hour = '08';
        this.minute = '00';
        this.meridiem = 'AM';
        this.schedulingTimeError = false;
        this.hourOptions = [
             '01',
             '02',
             '03',
             '04',
             '05',
             '06',
             '07',
             '08',
             '09',
             '10',
             '11',
             '12'
        ];
        this.minuteOptions = [
             '00',
             '05',
             '10',
             '15',
             '20',
             '25',
             '30',
             '35',
             '40',
             '45',
             '50',
             '55'
        ];
        this.meridiemValues = ['AM','PM'];
        this.userLanguage = this.CoreUserService.getLanguage().replace('_', '-');
        this.schedulingErrorMessage = '';
        this.schedulingErrorMessages = {
            TIME_TOO_EARLY: this.translationService.getLocalizedString('icm-outreach__email-compose--schedule-time-error'),
            NO_RECIPIENT: this.translationService.getLocalizedString('To schedule delivery, please specify at least one recipient.'),
            NO_SUBJECT: this.translationService.getLocalizedString('To schedule delivery, please specify a subject line for your email.'),
            NO_BODY: this.translationService.getLocalizedString('To schedule delivery, please provide text in the body of your email.'),
            MULTI_MISSING_ELEMENTS: this.translationService.getLocalizedString('To schedule delivery, please make sure that your email has at least one recipient, a subject line and text in the body.'),
            DAY_EMAIL_LIMIT_EXCEEDED: this.translationService.getLocalizedString(dailyLimitErrorMessage, {limits: ICM_RECIPIENTS_PER_DAY.toLocaleString(this.userLanguage)}),
            DISTRIBUTION_EMAIL_LIMIT_EXCEEDED: this.$translate.instant('icm-outreach__email-compose--recipient-limit-error', {limits: ICM_RECIPIENTS_PER_DISTRIBUTION.toLocaleString(this.userLanguage)}),
            NO_SENDER: this.translationService.getLocalizedString('Please select at least one sender'),
            SCHEDULED_DAILY_EMAIL_LIMIT_EXCEEDED: ''
        };
        this.firstNamePlaceholderText = this.$translate.instant('icm-web-influencers-outreach-compose__tinymce-editor--first-name-placeholder');
        this.lastNamePlaceholderText = this.$translate.instant('icm-web-influencers-outreach-compose__tinymce-editor--last-name-placeholder');

        this.preSelectedMediaLists = {};
        this.recipientsPerDistributionLimit = ICM_RECIPIENTS_PER_DISTRIBUTION;
        EntitlementService.getIcmRecipientsPerDistribution(this.recipientsPerDistributionLimit)
            .then( distributionLimit => {
                this.recipientsPerDistributionLimit = distributionLimit;
                this.schedulingErrorMessages.DISTRIBUTION_EMAIL_LIMIT_EXCEEDED = this.$translate.instant('icm-outreach__email-compose--recipient-limit-error', {limits: distributionLimit.toLocaleString(this.userLanguage)});
            })
            .catch(() => {
              var errorMessage = 'Unable to send outreach at this time. Please try again later.';
              this.showErrorMessage(this.translationService.getLocalizedString(errorMessage));
              this.closeCompose();
            });

        this.recipientsLabel = this.translationService.getLocalizedString('Recipients');
        this.MAX_RECIPIENTS_PER_DAY = ICM_RECIPIENTS_PER_DAY;
        this.emailSentToday = 0;
        EntitlementService.getIcmRecipientsPerDayLimit(ICM_RECIPIENTS_PER_DAY)
            .then( result => {
                this.MAX_RECIPIENTS_PER_DAY = result;
                this.schedulingErrorMessages.DAY_EMAIL_LIMIT_EXCEEDED = this.translationService.getLocalizedString(dailyLimitErrorMessage, {limits: result.toLocaleString(this.userLanguage)});
                this.updateRecipientsLabel(this.MAX_RECIPIENTS_PER_DAY);
            })
            .catch(function() {});

        this.disableSendNow = false;
        this.shouldSkipConfirmation = false;
        this.formChanged = false;

        this.selectedApprovedSender = {};
        this.approvedSenderArray = approvedSenderArray;
        this.genericErrorMsg = this.translationService.getLocalizedString('Something has gone wrong behind the scenes. Please try again later.');
        this.EMAIL_ADDRESS_REGEX = VALIDATION_CONSTANTS.EMAIL_REGEX;

        this.closeDialogInlineMessages();

        this.outreachBodyLimit = this.translationService.getLocalizedString('outreach-body__limit--reached-warning');

        /**
         * @description Fetch basepath and queryparams out of a url
         *
         * @param {string} url
         */
        var getRequestParams = function getRequestparams(url) {
            var params = {},
                pathStr = url.split('?')[0],
                searchStr = url.split('?')[1];

            if(searchStr !== undefined) {
                var paramsStr = searchStr.split('&');
                for(var key in paramsStr) {
                    if(paramsStr.hasOwnProperty(key)){
                        params[paramsStr[key].split('=')[0]] = paramsStr[key].split('=')[1];
                    }
                }
            }
            return {
                path: pathStr,
                params: params
            };
        };

        this.$scope.$on('$locationChangeSuccess', ($event, newUrl, oldUrl) => {
            var newLocationObject = getRequestParams(newUrl),
                oldLocationObject = getRequestParams(oldUrl);

            if(newLocationObject.path === oldLocationObject.path) {
                if(!newLocationObject.params.step || newLocationObject.params.step !== '2') {
                    this.composeStep = true;
                    this.schedulingOption = 'SAVE_DRAFT';
                    this.resetComposeFormErrors();
                    this.showDateTimePicker = false;
                    if(this.isValidComposeForm()){
                        this.disableSendNow = false;
                    }
                } else if(newLocationObject.params.step === '2') {
                    this.composeStep = false;
                    if(!this.isValidComposeForm() && this.schedulingOption === 'SCHEDULE') {
                        this.scheduledDateModel = null;
                        this.schedulingOption = 'SAVE_DRAFT';
                        this.scheduledDate = null;
                        this.showDateTimePicker = false;
                    }
                }
            }
        });

        this.totalRecipientCount = 0;
        this.validFileTypes = ['.DOC', '.DOCX', '.PPT', '.PPTX', '.XLS', '.XLSX', '.CSV', '.PDF', '.JPG', '.JPEG', '.PNG', '.TIFF', '.GIF'];

        toolbarButtons = 'fontselect | fontsizeselect | bold italic underline forecolor | alignleft alignright aligncenter alignjustify | bullist numlist outdent indent | icm_mailMerge icm_imageUploadV5 link code';
        if (this.dialogMode) {
            toolbarButtons = 'bold italic underline forecolor | alignleft alignright aligncenter alignjustify | bullist numlist outdent indent | icm_mailMerge icm_imageUploadV5 link code';
        }

        this.editorOptions = {
            /* jshint camelcase: false */
            extended_valid_elements: 'first_name,last_name',
            plugins: 'autolink autoresize image link lists textcolor code noneditable powerpaste',
            toolbar: toolbarButtons,
            link_assume_external_targets: true
        };

        // recipients variables
        this.currentTagInput = '';
        this.recipientTags= [];
        this.CONTACT_TYPE = 'contact';
        this.MEDIA_LIST_TYPE = 'mediaList';

        this.allowedTagsPattern = VALIDATION_CONSTANTS.EMAIL_REGEX_STRING;

        this.contactIcon = 'icon-user';
        this.mediaListIcon = 'icon-users2';
        this.manualEmailTagStyle = 'customEmailTag';
        this.approvedSendersListDropDown = [];
        // end reciepient variables

        // tag any existing recipients
        this.tagExistingRecipients();

        // load all of the media lists to use for the autocomplete search/drodown
        // add media lists present in the url to recipients
        this.mediaListArray = [];
        this.ContactManagerTagService.getAllTags().then( response => {
            this.mediaListArray = response;

            if(this.$location.search().mediaListIds){
                let mediaLists = this.$location.search().mediaListIds.split(',');

                mediaLists.forEach( mediaListId => {
                    this.mediaListArray.forEach( list => {
                        if(list.id === mediaListId){
                            this.addMediaListToRecipients(list);
                        }
                    });
                });
            }
        })
        .catch(function() {});

        this.contactAutocompleteList = [];
        $scope.$watch(angular.bind(this, function() {
            return this.currentTagInput;
        }), function(newModel, oldModel) {
            var searchMailIdChanged = (newModel.toLowerCase() !== oldModel.toLowerCase()),
                previousSearchSubsetOfNewSearch = false,
                query = {};

            // if the new search meets our min requirements, then get us some sources
            if(newModel.length && searchMailIdChanged && newModel.length >= 2) {

                // filter our media lists for autocomplete dropdown
                this.mediaListAutocompleteList = $filter('filter')(this.mediaListArray, {name: newModel});
                previousSearchSubsetOfNewSearch = newModel.toLowerCase().indexOf(oldModel.toLowerCase()) >= 0;
                if(!previousSearchSubsetOfNewSearch ||
                    (previousSearchSubsetOfNewSearch && this.ContactStreamDataFactory.totalContacts > 200) ||
                    this.ContactStreamDataFactory.totalContacts < 0) {
                    if(this.pendingQueryTimeout !== null) {
                        $timeout.cancel(this.pendingQueryTimeout);
                        this.pendingQueryTimeout = null;

                        // if we are clearing out a query timeout then we should disregard the oldModel,
                        // since it was never actually queried on
                        oldModel = '';
                    }

                    this.pendingQueryTimeout = $timeout(function() {
                        // clear out our timeout variable so we can continue tracking them correctly
                        this.pendingQueryTimeout = null;
                        query = {
                            anyKeywords: [newModel],
                            page: 0,
                            pageSize: 200
                        };

                        this.ContactStreamDataFactory.autocomplete(query).then(function() {
                            this.contactAutocompleteList = [];
                            this.ContactStreamDataFactory.contactArray.forEach(function(contact) {
                                contact.contactInfo.email.forEach(function(contactEmailObject) {
                                    if(typeof(contactEmailObject.address) === 'string' && contactEmailObject.address.length) {
                                        this.contactAutocompleteList.push({
                                            id: contact.id,
                                            name: contact.name.fullName,
                                            firstName: contact.name.firstName,
                                            lastName: contact.name.lastName,
                                            email: contactEmailObject.address,
                                            private: contact.systemData.policies.storage.private
                                        });
                                    }
                                }, this);
                            }, this);
                        }.bind(this))
                        .catch(function() {});
                    }.bind(this), 300);
                }
            } else if (newModel.length < 2) {
                this.contactAutocompleteList = [];
                this.mediaListAutocompleteList = [];
                this.ContactStreamDataFactory.resetSearch();
            }
        }.bind(this));
        // setup the approved sender for composing
        if(approvedSenderArray !== 'error') {
            if(Array.isArray(approvedSenderArray) && approvedSenderArray.length) {
                if(approvedSenderArray.length === 1) {
                    this.selectedApprovedSender = {
                        displayEmail: approvedSenderArray[0].name + ' (' + approvedSenderArray[0].email + ')',
                        payloadEmail: approvedSenderArray[0].name + ' <' + approvedSenderArray[0].email + '>',
                        id          : approvedSenderArray[0].id
                    };
                    if (this.isVerifiedDomain(approvedSenderArray[0].email)) {
                        this.selectedApprovedSender.displayEmail = this.selectedApprovedSender.displayEmail + ' - ' + this.$translate.instant('icm-outreach__email-from--verify-sender');
                    }

                    this.approvedSendersListDropDown.push(this.selectedApprovedSender);
                    this.isApprovedSenderReady = true;
                } else {
                    for(var i = 0; i < approvedSenderArray.length; i++) {
                        let sender = {
                            displayEmail: approvedSenderArray[i].name + ' (' + approvedSenderArray[i].email + ')',
                            payloadEmail: approvedSenderArray[i].name + ' <' + approvedSenderArray[i].email + '>',
                            id          : approvedSenderArray[i].id
                        };
                        if (this.isVerifiedDomain(approvedSenderArray[i].email)) {
                            sender.displayEmail = sender.displayEmail + ' - ' + this.$translate.instant('icm-outreach__email-from--verify-sender');
                        }
                        this.approvedSendersListDropDown.push(sender);
                    }
                    this.selectedApprovedSender = this.approvedSendersListDropDown[0];
                    this.isApprovedSenderReady = true;
                }
            } else {
                this.$location.url('/settings/email');
            }
        } else {
            // on error we should close the compose screen
            this.showErrorMessage(this.translationService.getLocalizedString('Unknown Sender'));
            this.shouldSkipConfirmation = true;
            this.closeCompose();
            this.shouldSkipConfirmation = false;
        }

        this.templateDropDownLabel = this.$translate.instant('icm-web-influencers-outreach-compose__template--default-label');
        this.templatesListDropDown = [{id: 0, title: this.templateDropDownLabel}];
        this.selectedTemplate = {};
        this.templatesList = templatesList;
        if (Array.isArray(this.templatesList) && this.templatesList.length > 0) {
            this.templatesListDropDown = this.templatesListDropDown.concat(this.templatesList);
        }
        this.selectedTemplate = this.templatesListDropDown[0];


        //Populate email distribution's
        this.populateDistribution(this.$routeParams.distributionId, this.$routeParams.state);

        var domainNames = [];
        if (Array.isArray(approvedSenderArray) && approvedSenderArray.length > 0) {
            domainNames = _.chain(approvedSenderArray)
            .filter(function(sender){
                return sender.is_approved;
            })
            .map(function(sender) {
                return sender.email.split('@').pop();
            })
            .uniq()
            .value();
        }
        if(!this.dialogMode) {
            this.OutreachBannerService.checkVerifiedDomains(domainNames, {
                attachTo: '.banner-space'
            }, this.sendgridDomainsArray);
        }
    }

    ContactManagerOutreachComposeController.prototype.templateChanged = function templateChanged(ev, selectedOption) {
        let currentTemplate = this.selectedTemplate,
            dialogHeader = this.$translate.instant('icm-outreach__template--confirm-load-header'),
            dialogDescription = this.$translate.instant('icm-outreach__template--confirm-load-description'),
            dialogOk = this.$translate.instant('icm-outreach__template--confirm-load-ok'),
            dialogCancel = this.$translate.instant('icm-outreach__template--confirm-load-cancel'),
            displayDialog = true;

        if((currentTemplate.body && this.messageBodyText === currentTemplate.body) || this.messageBodyText.length === 0) {
            displayDialog = false;
        }

        if (displayDialog) {
            this.$mdDialog.show(
                this.$mdDialog.mwConfirm()
                    .class('icm-confirmation-modal')
                    .title(dialogHeader)
                    .textContent(dialogDescription)
                    .ok(dialogOk)
                    .cancel(dialogCancel)
                    .targetEvent(ev)
            ).then(
                () => {
                    // replace
                    this.replaceWithTemplate(selectedOption);
                },
                () => {
                    // cancel
                    this.selectedTemplate = currentTemplate;
                }
            );
        }
        else {
            this.replaceWithTemplate(selectedOption);
        }
    };

    ContactManagerOutreachComposeController.prototype.replaceWithTemplate = function replaceWithTemplate(selectedOption) {
        this.setFormDirty();
        this.closeDialogInlineMessages();

        this.selectedTemplate = selectedOption;
        this.messageBodyText = selectedOption.body;
        this.templateId = selectedOption.id;
    };

    ContactManagerOutreachComposeController.prototype.isVerifiedDomain = function (emailAddress) {
        let isVerifiedDomain = false;
        let senderDomain;

        const emailRegexMatch = emailAddress.match(/@(.+)$/);

        if(emailRegexMatch) {
            senderDomain = emailRegexMatch[1];

            if(Array.isArray(this.sendgridDomainsArray) && this.sendgridDomainsArray.length) {
                isVerifiedDomain = this.sendgridDomainsArray.some(function(sendgridDomainObject) {
                    if(sendgridDomainObject.domain) {
                        if(sendgridDomainObject.domain.toLowerCase() === senderDomain.toLowerCase()) {
                            return (sendgridDomainObject.isVerified === true);
                        }
                    }

                    return false;
                });
            }
        }

        return isVerifiedDomain;
    };

    ContactManagerOutreachComposeController.prototype.updateRecipientsLabel = function updateRecipientsLabel(perDayLimit) {
        var translateScope,
            endOfDayToday = this.adjustDateToEndOfDay(this.moment.utc()),
            relevantMsg,
            hoursUntilReset = this.getTotalHoursBetweenDates(this.moment.utc(), endOfDayToday);

        this.OutreachService.getLastDayCount(endOfDayToday.toISOString(), this.$routeParams.distributionId)
            .then(function getLastDayCountSuccess(lastDayCount) {
                if(isNaN(lastDayCount)) {
                    lastDayCount = 0;
                }
                this.emailSentToday = lastDayCount;

                if (lastDayCount === 0) {
                    relevantMsg = 'icm-web-influencers-outreach__toast-usage-message--daily-limit';
                    translateScope = {
                        perDayLimit: perDayLimit
                    };
                } else{
                    relevantMsg = 'icm-web-influencers-outreach__toast-usage-message--available-before-reset';
                    translateScope = {
                        available: perDayLimit - lastDayCount,
                        hoursLeft: hoursUntilReset,
                        perDayLimit: perDayLimit
                    };
                }

                this.translationService.getLocalizedString(relevantMsg, translateScope, true).then(function(translatedText) {
                    this.recipientsLabel = translatedText;
                }.bind(this))
                .catch(function() {});
            }.bind(this))
            .catch(function() {});
    };

    /**
     * @description Show error message
     *
     * @param {String} error message
     */
    ContactManagerOutreachComposeController.prototype.showErrorMessage = function showErrorMessage(message) {
        if(!message) {
            return;
        }
        if(this.dialogMode) {
            this.errorOnDialog = true;
            this.inlineErrorMessage = message;
        } else {
            this.DialogService.flashError(message);
        }
    };

    ContactManagerOutreachComposeController.prototype.timeSelectionChanged = function timeSelectionChanged() {
        this.schedulingTimeError = false;
        this.perScheduledDayLimitExceeded = false;
        this.disableSendNow = false;
    };

    ContactManagerOutreachComposeController.prototype._convertDateTimeStringToUtc = function _convertDateTimeStringToUtc(dateString, timeString) {
        var userTimezone = this.ICMUserService.getTimezone(),
            formattedDateString = this.moment(dateString, 'MMM DD, YYYY').format('YYYY-MM-DD'),
            formattedDateTimeString = formattedDateString + 'T' + timeString,
            userDateTimeObject = this.moment.tz(formattedDateTimeString, userTimezone),
            utcTimezoneString = userDateTimeObject.toISOString();

        return utcTimezoneString;
    };

    /**
     * @description Handles the click event when scheduling option is changed
     *
     * @param {string} scheduling option
     */
    ContactManagerOutreachComposeController.prototype.schedulingOptionClickHandler = function schedulingOptionClickHandler(scheduleOption) {
        this.schedulingOption = scheduleOption;

        if(scheduleOption === 'SAVE_DRAFT') {
            this.showDateTimePicker = false;
        } else {
            this.showDateTimePicker = true;
            this.datePickerElement = angular.element('.datepickerVisible');
            this.dateInput = angular.element('.dateInput');

            if(this.scheduledDateModel === null) {
                this.scheduledDateModel = this.moment.tz(this.dateInput.val(), this.MOMENT_MEDIUM_DATE, this.ICMUserService.getTimezone()).format(this.dateTimeFormat.dateFormat);
            }
            else if(this.perScheduledDayLimitExceeded) {
                var displayDate = this.moment(this.scheduledDateModel);
                this.datePickerElement.datepicker('option','minDate', new Date(displayDate));
            }
            else {
                this.datePickerElement.datepicker('setDate', new Date(this.scheduledDateModel));
            }
        }
    };

    /**
     * @description Fetches distribution and populate messageBodyText and subject to duplicate distribution (in case of duplicate action)
     *              Fetches distribution and populate messageBodyText and subject and recipients to draft and scheduled email distribution (in case of draft and scheduled mails)
     *
     * @param {string} distributionId - unique Id of distribution
     * @param {string} state - state 'duplicate' of distribution
     */

    ContactManagerOutreachComposeController.prototype.populateDistribution = function populateDistribution(distributionId, state) {
        var sanitizeAttachment;

        if(distributionId) {
            this.OutreachService.getEmailById(distributionId).then((response) => {
                if(response) {
                    this.preSavedDistribution = response;
                    this.messageBodyText = response.bodyHtml;
                    this.subject = response.subject;
                    this.modified = response.modified;

                    if (response.templateId) {
                        this.templateId = response.templateId;
                        this.selectedTemplate = this.templatesList.find(x => x.id === response.templateId);
                    }

                    //load attachments
                    if(response.attachments && response.attachments.length) {
                        response.attachments.forEach((attachment) => {
                            this.attachments.push(sanitizeAttachment(attachment));
                        });
                    }

                    if(state !== 'duplicate') {
                        // load up recipients and mediaLists
                        var contactRecipients = response.recipientsMetaData.recipients,
                            mediaListRecipients = response.recipientsMetaData.mediaLists,
                            contactRecipientsEmails = [];

                        if(Array.isArray(contactRecipients) && contactRecipients.length) {
                            contactRecipients.forEach(function(contactRecipient) {
                                contactRecipientsEmails.push(contactRecipient.email);
                            }, this);
                        }

                        this.checkForUnsubscribedContacts(contactRecipientsEmails).then((response) => {
                            contactRecipients.forEach(function(contactRecipient) {
                                this.addContactToRecipients(contactRecipient, response.to);
                            }, this);
                        })
                        .catch(() => {
                            this.showErrorMessage(this.genericErrorMsg);
                        });

                        if(Array.isArray(mediaListRecipients) && mediaListRecipients.length) {
                            mediaListRecipients.forEach(function(mediaListRecipient) {
                                this.addMediaListToRecipients(mediaListRecipient);
                            }, this);
                        }
                    }

                    if(response.status === 'scheduled' && state !== 'duplicate') {
                        //load schedule date
                        if(response.scheduledDate !== null && !response.sendImmediately) {
                            this.schedulingOption = 'SCHEDULE';
                            this.showDateTimePicker = true;
                            this.scheduledDateModel = this.moment(response.scheduledDate).tz(this.userTimezoneString).format(this.dateTimeFormat.momentDateFormat);
                            this.scheduledTimeModel = this.moment(response.scheduledDate).tz(this.userTimezoneString).format(this.dateTimeFormat.timeFormat);

                            this.scheduledDate = response.scheduledDate;

                            var twelveHourTimeObj = this._convert24hourTo12hourTime(this.scheduledTimeModel);
                            this.hour = twelveHourTimeObj.hour;
                            this.minute = twelveHourTimeObj.minute;
                            this.meridiem = twelveHourTimeObj.amPm.toUpperCase();
                        }
                    }
                    var distributionSender = this.approvedSendersListDropDown.filter((approveSender) =>{
                        return approveSender.id === response.approvedSender.id;
                    });

                    if( distributionSender.length > 0) {
                        this.selectedApprovedSender = distributionSender[0];
                    }
                }
            }).catch(() => {
                var errorMessage = 'Unable to retrieve email';
                this.showErrorMessage(this.translationService.getLocalizedString(errorMessage));
            });
        }

        if (this.$location.search().templateId) {
            this.templateId = parseInt(this.$location.search().templateId);
            this.selectedTemplate = this.templatesList.find(x => x.id === this.templateId);
            if (this.selectedTemplate) {
                this.messageBodyText = this.selectedTemplate.body;
            }
        }

        sanitizeAttachment = function sanitizeAttachment(attachment) {
            var displayFileName,
                displayFileSize,
                displayFileExt;

            displayFileSize = this.validateFileSize(attachment.size);
            displayFileExt =  attachment.fileLink.substr(attachment.fileLink.lastIndexOf('.')).toUpperCase();

            if(!displayFileSize || displayFileExt === 'invalid file type') {
                return false;
            }

            this.totalFileAttachedSize += attachment.size;
            displayFileName = attachment.fileLink.substr(attachment.fileLink.lastIndexOf('/')+1, attachment.fileLink.lastIndexOf('.') - attachment.fileLink.lastIndexOf('/') - 1);

            attachment.displayFileName = decodeURIComponent(displayFileName);
            attachment.displayFileExt = displayFileExt;
            attachment.displayFileSize = displayFileSize;

            return attachment;
        }.bind(this);
    };

    /** @description Function deep compares the object by angular.equals (stripping off $$hashKey in objects in this.approvedSendersListDropdown populated from backend call)
     *
     * @param {Array} Array of objects to be compared into
     *        {Object} Object to be searched in array
     *
     * @returns {Number} Index in Array, else -1
     */
    ContactManagerOutreachComposeController.prototype.indexOfObject = function indexOfObject(arr, obj) {
        for(var i = 0; i < arr.length; i++){
            if(angular.equals(arr[i], obj)){
                return i;
            }
        }
        return -1;
    };

    ContactManagerOutreachComposeController.prototype.checkCanSend = function checkCanSend() {
        let showTermsPrompt = false;
        const mrShowUpdatedTerms0923 = 'mrShowUpdatedTerms0923';

        const translatedTitle = this.$translate.instant('icm-web-influencers-outreach-compose__updated-terms-modal--title');
        const translatedContent = this.$translate.instant('icm-web-influencers-outreach-compose__updated-terms-modal--content', {openingTag: '{{openingTag}}', closingTag: '{{closingTag}}'})
            .replace('{{openingTag}}', '<a style="color: #2795b6;" href="https://www.meltwater.com/en/product-specific-terms" target="_blank">')
            .replace('{{closingTag}}', '</a>');

        const translatedOkButton = this.$translate.instant('icm-web-influencers-outreach-compose__updated-terms-modal--ok-button');
        const translatedCancelButton = this.$translate.instant('icm-web-influencers-outreach-compose__updated-terms-modal--cancel-button');

        let deferred = this.$q.defer();

        this.ManifestService.getCompanyOverrides()
            .then(function (overrides) {
                if(overrides && overrides[mrShowUpdatedTerms0923] === true) {
                    showTermsPrompt = true;
                }
            })
            .finally(() => {
                if(showTermsPrompt) {
                    this.$mdDialog
                        .show(
                            this.$mdDialog.mwConfirm()
                                .title(translatedTitle)
                                .htmlContent(this.$sce.trustAsHtml(translatedContent))
                                .ok(translatedOkButton)
                                .cancel(translatedCancelButton)
                        )
                        .then(
                            () => {
                                this.ManifestService.setOverride(mrShowUpdatedTerms0923, false); // override the manifest in browser so we don't need to wait for the call & manifest refresh
                                this.MrCompanyService.setAcceptedTerms();
                                deferred.resolve();
                            },
                            () => {
                                deferred.reject();
                            }
                        );
                } else {
                    deferred.resolve();
                }
            });

        return deferred.promise;
    };

    /**
     * @description Handles click of send later button and takes to step two of compose modal
     *
     * @param {}
     */
    ContactManagerOutreachComposeController.prototype.sendLater = function sendLater() {
        this.checkCanSend().then(() => {
            this.$location.search('step', '2');
            this.composeStep = false;
            this.perDayLimitExceeded = false;
            this.disableSendNow = false;
            this.getComposeFormErrors();

            if(this.schedulingOption === 'SCHEDULE') {
                this.schedulingOptionClickHandler('SCHEDULE');
            }
        });
    };

    /**
     * @description Handles the event of tagging existing recipients
     *
     * @param {}
     */
    ContactManagerOutreachComposeController.prototype.tagExistingRecipients = function tagExistingRecipients() {
        var contactRecipients = this.ICMEmailService.getContactRecipients(),
            contactRecipientsQuery = this.ICMEmailService.getContactRecipientsQuery(),
            mediaListRecipients = this.ICMEmailService.getMediaListRecipients(),
            contactRecipientsEmails = [];

        if (Array.isArray(contactRecipients) && 'string' === typeof contactRecipientsQuery.q) {
            this.getRecipientsFromQuery(contactRecipientsQuery).then(function() {
                contactRecipients = Array.concat(contactRecipients, this.ICMEmailService.getContactRecipients());
                this.finishTagging(contactRecipients, mediaListRecipients, contactRecipientsEmails);
            }.bind(this))
            .catch(function() {});
        } else {
            this.finishTagging(contactRecipients, mediaListRecipients, contactRecipientsEmails);
        }
    };

    ContactManagerOutreachComposeController.prototype.finishTagging = function finishTagging(contactRecipients, mediaListRecipients, contactRecipientsEmails) {
        // load up any existing recipients
        if(Array.isArray(contactRecipients) && contactRecipients.length) {
            contactRecipients.forEach(function(contactRecipient) {
                if(contactRecipient.email !== '') {
                    contactRecipientsEmails.push(contactRecipient.email);
                }
            }, this);
        }

        if(contactRecipientsEmails.length) {
            this.checkForUnsubscribedContacts(contactRecipientsEmails).then(function(response){
                contactRecipients.forEach(function(contactRecipient) {
                    if(contactRecipient.email) {
                        this.addContactToRecipients(contactRecipient, response.to);
                    }
                }, this);
            }.bind(this))
            .catch(function() {
                this.showErrorMessage(this.genericErrorMsg);
            }.bind(this));
        }

        if(Array.isArray(mediaListRecipients) && mediaListRecipients.length) {
            mediaListRecipients.forEach(function(mediaListRecipient) {
                this.addMediaListToRecipients(mediaListRecipient);
            }, this);
        }
    };

    /**
     * @description Converting language code to editorLanguage
     *
     * @param {}
     */
    ContactManagerOutreachComposeController.prototype.convertLanguageCode = function convertLanguageCode() {
        var lang = this.editorLanguage.toLowerCase();
        return (lang === 'pt') ? 'pt_pt' : lang;
    };

    /**
     * Callback for when manually adding a tag to ngInputs
     * Current implementation only allows email addresses added manually
     *
     * @param {string} tag - value that was just tagged
     */
    ContactManagerOutreachComposeController.prototype.onTagAdded = function onTagAdded(tag) {
        var contactExisted = false;
        this.contactAutocompleteList.some(function(contact){
            if(contact.email.toLowerCase() === tag.display.toLowerCase()) {
                this.recipientTags.pop();
                this.recipientTags.push({
                    class: '',
                    display: contact.name || contact.email,
                    icon: this.contactIcon,
                    trackBy: contact.email,
                    metaData: {
                        type: this.CONTACT_TYPE,
                        contact: contact
                    }
                });
                this.currentTagInput = false;
                this.addContactToRecipients(contact);
                contactExisted = true;
                return true;
            }
        }.bind(this));
        // update the added tag to match our expected object structure
        if(!contactExisted) {
            var tagObj ={
                class: this.manualEmailTagStyle,
                display: tag.display,
                icon: this.contactIcon,
                title: '',
                trackBy: tag.display,
                metaData: {
                    type: this.CONTACT_TYPE,
                    contact: {
                        id: null,
                        name: tag.display,
                        email: tag.display,
                        private: true
                    }
                }
            };
            this.recipientTags.pop();
            this.recipientTags.push(tagObj);
            this.checkForUnsubscribedContacts([tag.display]).then(function(response){
                var result = response.to[tag.display.trim().toLowerCase()];
                tagObj.title = result ? tag.display : this.translationService.getLocalizedString('Contact unsubscribed. Email will not be sent.');
            }.bind(this))
            .catch(function() {
                this.showErrorMessage(this.genericErrorMsg);
            }.bind(this));
        }

        // update counts
        this.totalRecipientCount = this.getDedupCountOfRecipientEmails();

    };

    /**
     * @description adding contacts to recipients array
     *
     * @param {object} contact object
     * @param {object} unsubscribed emails Object
     */
    ContactManagerOutreachComposeController.prototype.addContactToRecipients = function addContactToRecipients(contact, unsubscribedObject) {
        this.resetAutocomplete();
        if(contact && !unsubscribedObject) {
            this.checkForUnsubscribedContacts([contact.email]).then(function(response){
                unsubscribedObject = response.to;
                this.addTagToRecipients(contact, unsubscribedObject);
            }.bind(this))
            .catch(function() {
                this.showErrorMessage();
            }.bind(this));
        } else {
            this.addTagToRecipients(contact, unsubscribedObject);
        }
    };

    ContactManagerOutreachComposeController.prototype.getRecipientsFromQuery = function addQueryToRecipients(query) {
        if (!query.mediaListIds) {
            return this.ContactStreamDataFactory.getMasterList(query).then(function(response) {
                this.ICMEmailService.setContactRecipients(response.hits);
            }.bind(this))
            .catch(function() {});
        } else {
            return this.ContactStreamDataFactory.getByMediaListIds(query).then(function(response) {
                this.ICMEmailService.setContactRecipients(response.hits);
            }.bind(this))
            .catch(function() {});
        }
    };

    /**
     * @description Adding medialists to recipients array
     *
     * @param {object} medialist object
     */
    ContactManagerOutreachComposeController.prototype.addMediaListToRecipients = function addMediaListToRecipients(mediaList) {
        this.resetAutocomplete();
        if(this.shouldAddTag(mediaList.name)) {
            this.cacheMediaList(mediaList).then(function() {
                var mediaListRecipients = [],
                    recipientsInMediaList = [],
                    comparator,
                    len;
                // gather up relevant info from the media lists
                this.cachedMediaLists[mediaList.id].hits.map(function(contactQuiddity) {
                    var contact = contactQuiddity,
                        contactName = '',
                        contactEmail = '';

                    if(contact.name) {
                        contactName = [contact.name.firstName, contact.name.middleInitial, contact.name.lastName].join(' ');
                    }

                    if(contact.contactInfo && Array.isArray(contact.contactInfo.email) && contact.contactInfo.email.length) {
                        const primary = contact.contactInfo.email.sort((a, b) => {
                            if (a.overlayMetadata && b.overlayMetadata || !a.overlayMetadata && !b.overlayMetadata) {
                                if ((!a.primary && b.primary)) {
                                    return 1;
                                } else if (a.primary && !b.primary) {
                                    return -1;
                                }
                            } else if (!a.overlayMetadata && b.overlayMetadata) {
                                return 1;
                            } else if (a.overlayMetadata && !b.overlayMetadata) {
                                return -1;
                            }
                            return 0;
                        });
                        contactEmail = primary[0].address;
                    }
                    mediaListRecipients.push({
                        id: contact.id,
                        name: contactName,
                        firstName: contact.name.firstName,
                        lastName: contact.name.lastName,
                        email: contactEmail,
                        private: contact.systemData.policies.storage.private
                    });
                });

                // collect recipients within mediaList to show on hover
                len = mediaListRecipients.length;
                comparator = (len <= 5) ? len : 5;
                for(var i=0; i < comparator; i++) {
                    recipientsInMediaList.push(mediaListRecipients[i].email);
                }

                recipientsInMediaList = recipientsInMediaList.toString().replace(/,/g,'\n');

                if(len > 5) {
                    recipientsInMediaList += '\n' + (len-5) + ' ' + this.translationService.getLocalizedString('more recipients...');
                }
                // tag the media list
                this.recipientTags.push({
                    class: '',
                    display: mediaList.name + ' (' + this.cachedMediaLists[mediaList.id].count + ')',
                    icon: this.mediaListIcon,
                    title: recipientsInMediaList,
                    trackBy: mediaList.name,
                    metaData: {
                        type: this.MEDIA_LIST_TYPE,
                        mediaList: {
                            id: mediaList.id,
                            name: mediaList.name,
                            recipients: mediaListRecipients,
                            count: this.cachedMediaLists[mediaList.id].count
                        }
                    }
                });
                this.preSelectedMediaLists[mediaList.id] = mediaList;
                // update counts
                this.totalRecipientCount = this.getDedupCountOfRecipientEmails();
            }.bind(this))
                .catch(function() {});
        }
    };

    ContactManagerOutreachComposeController.prototype.getDedupCountOfRecipientEmails = function getDedupCountOfRecipientEmails(){
        let allRecipientEmails = {};
        // use object keys to keep track of what emails are dups so we don't have to iterate through an array
        this.recipientTags.forEach((tag) => {
            if(tag.metaData.type === this.MEDIA_LIST_TYPE){
                tag.metaData.mediaList.recipients.forEach((recipient) => {
                    if(recipient.email && !allRecipientEmails[recipient.email]){
                        // only really need the keys just set it to something value doesn't matter
                        allRecipientEmails[recipient.email] = true;
                    }
                });
            } else if (tag.metaData.type === this.CONTACT_TYPE) {
                if(tag.metaData.contact.email && !allRecipientEmails[tag.metaData.contact.email]){
                    // only really need the keys just set it to something value doesn't matter
                    allRecipientEmails[tag.metaData.contact.email] = true;
                }
            }
        });
        //return actual count of recipients after deduping and removing no email contacts
        return Object.keys(allRecipientEmails).length;
    };

    /**
     * @description Handling removal of recipient tag callback
     *
     * @param {object} tag object
     */
    ContactManagerOutreachComposeController.prototype.onTagRemoved = function onTagRemoved(tag) {
        var maxRecipientsPerDay = this.MAX_RECIPIENTS_PER_DAY;

        if(tag.metaData.type === this.MEDIA_LIST_TYPE){
            delete this.preSelectedMediaLists[tag.metaData[this.MEDIA_LIST_TYPE].id];
        }

        this.setFormDirty();
        this.totalRecipientCount = this.getDedupCountOfRecipientEmails();
        if(this.totalRecipientCount <= maxRecipientsPerDay) {
            this.perDayLimitExceeded = false;
            this.disableSendNow = false;
        }
    };

    /**
     * @description reset autocomplete list
     *
     * @param {}
     */
    ContactManagerOutreachComposeController.prototype.resetAutocomplete = function resetAutocomplete() {
        this.currentTagInput = '';
        this.contactAutocompleteList = [];
        this.mediaListAutocompleteList = [];
    };

    /**
     * @description check if new tag entered is valid to add a new tag
     *
     * @param {string}
     */
    ContactManagerOutreachComposeController.prototype.shouldAddTag = function shouldAddTag(newTrackByValue) {
        return this.recipientTags.every(function(recipientTag) {
            return recipientTag.trackBy !== newTrackByValue;
        });
    };

    /**
     * @description cache media list
     *
     * @param {Object} medialist object
     */
    ContactManagerOutreachComposeController.prototype.cacheMediaList = function(mediaList) {
        var deferred = this.$q.defer(),
            query;

        if(!this.cachedMediaLists[mediaList.id]) {
            query = {
                mediaListIds: [mediaList.id],
                page: 0,
                pageSize: this.recipientsPerDistributionLimit,
                contactsForReceipientList: true
            };
            this.ContactManagerTagService.getContactsByMediaListIds(query)
                .then(function(response) {
                    // media list count can be -1 in certain scenarios. we should treat that as 0 for UI
                    if(response.count < 0) {
                        response.count = 0;
                    }

                    this.cachedMediaLists[mediaList.id] = response;
                    deferred.resolve();
                }.bind(this))
                .catch(function(error) {
                    deferred.reject(error);
                });
        } else {
            deferred.resolve();
        }

        return deferred.promise;
    };

    /**
     * @description reset autocomplete onblur from tagging
     *
     * @param {}
     */
    ContactManagerOutreachComposeController.prototype.onBlurFromTagging = function onBlurFromTagging() {
        // TODO: need to refocus!
        this.resetAutocomplete();
    };

    /**
     * @description close inline messages on dialog onfocus of recipients dialog
     *
     * @param {}
     */
    ContactManagerOutreachComposeController.prototype.onFocusRecipientsField = function onFocusRecipientsField() {
        this.closeDialogInlineMessages();
    };

    /**
     * @description close inline messages on dialog
     *
     * @param {}
     */
    ContactManagerOutreachComposeController.prototype.closeDialogInlineMessages = function closeDialogInlineMessages() {
        if(!this.dialogMode) {
            return;
        }
        this.errorOnDialog = false;
        this.inlineErrorMessage = '';
    };

    ContactManagerOutreachComposeController.prototype.generateSchedulingTimeErrorMessage = function generateSchedulingTimeErrorMessage() {
        var _this = this,
        scheduledDailyLimitErrorMessage = 'icm-outreach__email-schedule--limit-error';

        _this.schedulingErrorMessages.SCHEDULED_DAILY_EMAIL_LIMIT_EXCEEDED = _this.$translate.instant(scheduledDailyLimitErrorMessage, {
            selectedDate: _this.moment(_this.scheduledDate).format(_this.dateTimeFormat.momentDateFormat),
            limits: _this.MAX_RECIPIENTS_PER_DAY.toLocaleString(_this.userLanguage)
        });
    };

    ContactManagerOutreachComposeController.prototype.resetComposeFormErrors = function resetComposeFormErrors() {
        this.composeFormError = false;
        this.multipleFormErrors = false;
        this.missinRecipientsError = false;
        this.missingSubjectError = false;
        this.missingBodyError = false;
        this.missingSenderError = false;
        this.distroLimitError = false;
    };

    /**
     * @description Binds schedulingError states to layout
     *
     * @param {}
     * @return String (if error)
     *         false (if no error)
     */
    ContactManagerOutreachComposeController.prototype.getComposeFormErrors = function getComposeFormErrors() {
        this.resetComposeFormErrors();

        var formErrorCount = 0;
        if(!this.recipientTags.length) {
            formErrorCount++;
            this.missinRecipientsError = true;
            this.composeFormError = true;
        }
        if(this.subject === '') {
            formErrorCount++;
            this.missingSubjectError = true;
            this.composeFormError = true;
        }
        if(this.messageBodyText === '') {
            formErrorCount++;
            this.missingBodyError = true;
            this.composeFormError = true;
        }

        if(formErrorCount > 1) {
            this.multipleFormErrors = true;
        }

        if(this.indexOfObject(this.approvedSendersListDropDown, this.selectedApprovedSender) === -1) {
            this.missingSenderError = true;
            this.composeFormError = true;
        }

        if(this.totalRecipientCount > this.recipientsPerDistributionLimit) {
            this.distroLimitError = true;
            this.composeFormError = true;
        }
    };

    /**
     * @description get LastDay Email recipient count
     *
     * @param date
     * @param schedulingOption
     * @param distributionId
     * @param state
     * @returns {Promise}
     */
    ContactManagerOutreachComposeController.prototype.getLastDayCount = function getLastDayCount(date, schedulingOption, distributionId, state) {
        var deferred = this.$q.defer();

        if(schedulingOption === 'SAVE_DRAFT') {
            //No need to check in case of draft email
            deferred.resolve(0);
        } else {
            if(distributionId && state === undefined) {
                this.OutreachService.getLastDayCount(date, distributionId).then( function(count) {
                    count = count + this.totalRecipientCount;
                    deferred.resolve(count);
                }.bind(this))
                .catch(function(error) {
                    deferred.reject(error);
                });
            } else {
                this.OutreachService.getLastDayCount(date).then( function(count) {
                    count = count + this.totalRecipientCount;
                    deferred.resolve(count);
                }.bind(this))
                .catch(function(error) {
                    deferred.reject(error);
                });
            }
        }
        return deferred.promise;
    };

    /**
     * @description display preview email modal
     *
     */
    ContactManagerOutreachComposeController.prototype.showPreviewEmailModal = function showPreviewEmailModal() {
        this.checkCanSend().then(() => {
            let _this = this;

            this.hasFirstNameMailMergeField = this.messageBodyText.indexOf(this.firstNamePlaceholderText) > -1;
            this.hasLastNameMailMergeField = this.messageBodyText.indexOf(this.lastNamePlaceholderText) > -1;
            this.$mdDialog.show({
                bindToController: true,
                targetEvent: event,
                locals: {
                    EMAIL_ADDRESS_REGEX: this.EMAIL_ADDRESS_REGEX,
                    hasFirstNameMailMergeField: this.hasFirstNameMailMergeField,
                    hasLastNameMailMergeField: this.hasLastNameMailMergeField,
                    data: {},
                    cancelDialog: function() {
                        _this.$mdDialog.cancel();
                    },
                    okDialog: function(data) {
                        _this.sendPreviewDistribution(data);
                        _this.$mdDialog.hide();
                    }
                },
                template: `
                    <md-dialog id="icm-outreach-preview-modal" class="mw-mini-modal mw-mini-modal--wide" aria-label="" layout="column">
                        <mw-outreach-preview-modal class="mw-mini-modal-wrapper" layout="column" email-pattern="$ctrl.EMAIL_ADDRESS_REGEX" show-first-name-field="$ctrl.hasFirstNameMailMergeField" show-last-name-field="$ctrl.hasLastNameMailMergeField" ok-callback="$ctrl.okDialog(data)" cancel-callback="$ctrl.cancelDialog()"></mw-outreach-preview-modal>
                    </md-dialog>
                `,
                // This is a globally available controller for the purposes of attaching locals for data binding
                controller: 'MwMiniModalDialogController',
                controllerAs: '$ctrl'
            });
        });
    };

    /**
     * @description method for sending preview email.
     *
     * @param recipientObject
     */
    ContactManagerOutreachComposeController.prototype.sendPreviewDistribution = function sendPreviewDistribution(recipientObject) {
        var attachmentObject,
            sender = this.selectedApprovedSender.payloadEmail || '',
            senderId = this.selectedApprovedSender.id || '',
            recipient = {
                private : true,
                email : recipientObject.email,
                name : recipientObject.email,
                lastName: recipientObject.lastName,
                firstName: recipientObject.firstName,
                id : null
            },
            payload = {
                recipients: [recipient],
                mediaLists: [],
                subject: this.subject + ' (' + this.$translate.instant('icm-outreach__email-preview--preview-subject-tag') + ')',
                bodyHtml: this.messageBodyText,
                fromAddress: sender,
                userLanguage: this.editorLanguage,
                approvedSenderId: senderId,
                firstNamePlaceholder: this.firstNamePlaceholderText,
                lastNamePlaceholder: this.lastNamePlaceholderText,
                sendImmediately: true,
                isPreview: true,
                attachments: []
            };

        if (this.templateId) {
            payload.templateId = this.templateId;
        }

        this.attachments.forEach(function addAttachment(attachment) {
            attachmentObject = {
                fileLink: attachment.fileLink,
                size: attachment.size
            };
            payload.attachments.push(attachmentObject);
        }.bind(this));

        this.trackEvent('preview', payload.recipients.length);
        this.OutreachService.outreach(payload, this.fileUploadList)
            .catch(function onError() {
                this.showErrorMessage(this.genericErrorMsg);
            }.bind(this));
    };

    /**
     * @description method for checking email body content for Base64 encoded images
     *
     * @param htmlInput
     */
    ContactManagerOutreachComposeController.prototype.containsInvalidImage = function containsInvalidImage(htmlInput){
        let base64Regex = /src=\"data:image\/([a-zA-Z]*);base64,([^\"]*)\"/g;
        let blobRegex = /src\=\"blob\:[a-zA-Z]{3,5}\:\/\/[\S]*\"/g;

        return !!(base64Regex.test(htmlInput) || blobRegex.test(htmlInput));
    };

    ContactManagerOutreachComposeController.prototype.bodyLimitExceeded = function bodyLimitExceeded() {
        // check byte count is less than 10 mb (1024 X 1024 X 10)
        return (this.messageBodyText.length) >= 200000;
    };

    /**
     * @description method for sending email now.
     *
     * @param sendNow
     */
    ContactManagerOutreachComposeController.prototype.saveMail = function saveMail(sendNow) {
        this.checkCanSend().then(() => {
            this.disableSendNow = true;
            var sendingPriority;

            // Recall function if the user hits the send button too early
            if(this.containsInvalidImage(this.messageBodyText)){
                this.$timeout(()=>{
                    this.saveMail(sendNow);
                }, 500);

                return;
            }

            if (sendNow) {
                sendingPriority = {
                    prio: 'send now',
                    date: this.adjustDateToEndOfDay(this.moment.utc()).toISOString()
                };
            } else if (!sendNow) {
                if(this.schedulingOption === 'SCHEDULE') {
                    // for scheduled emails we need to define the "scheduledDate" so that the API request to fetch the "last day count", will calculate based on scheduled day & not today
                    this.scheduledDate = this.setScheduledDate();

                    // the setScheduledDate method call sets the schedulingTimeError flag. if there is a time error, then dont continue to make more requests.
                    if(this.schedulingTimeError) {
                        this.disableSendNow = false;
                        return;
                    }
                }

                sendingPriority = {
                    prio: this.schedulingOption,
                    date: this.adjustDateToEndOfDay(this.scheduledDate).toISOString()
                };
            }

            this.getLastDayCount(sendingPriority.date, sendingPriority.prio, this.$routeParams.distributionId, this.$routeParams.state)
                .then(function(count) {
                    var mailType,
                        maxRecipientsPerDay = this.MAX_RECIPIENTS_PER_DAY,
                        sender = this.selectedApprovedSender.payloadEmail || '',
                        senderId = this.selectedApprovedSender.id || '',
                        payload = {
                            recipients: [],
                            mediaLists: [],
                            subject: this.subject,
                            modified: this.modified,
                            bodyHtml: this.messageBodyText,
                            fromAddress: sender,
                            userLanguage: this.editorLanguage,
                            approvedSenderId: senderId,
                            firstNamePlaceholder: this.firstNamePlaceholderText,
                            lastNamePlaceholder: this.lastNamePlaceholderText,
                            //This is for stat tracking purposes
                            usedPlaceholders: (this.messageBodyText.indexOf(this.firstNamePlaceholderText) > -1 || this.messageBodyText.indexOf(this.lastNamePlaceholderText) > -1)
                        };

                    if (this.templateId) {
                        payload.templateId = this.templateId;
                    }

                    if(sendNow) {
                        payload.sendImmediately = true;
                        if(count <= maxRecipientsPerDay) {
                            mailType = 'sent';
                        }
                    } else {
                        payload.sendImmediately = false;

                        if (this.schedulingOption === 'SAVE_DRAFT') {
                            this.scheduledDate = this.scheduledDateModal = null;
                            payload.scheduledDate = null;
                            mailType = 'draft';
                        } else {
                            payload.scheduledDate = this.scheduledDate;
                            mailType = 'scheduled';
                        }
                    }

                    // Check for max recipient error case
                    if(count > maxRecipientsPerDay) {
                        // if the user was attempting to schedule an outreach and hit a num of recipient issue. need to dynamially build the error message to display.
                        if(this.schedulingOption === 'SCHEDULE' && payload.sendImmediately === false) {
                            this.perScheduledDayLimitExceeded = true;
                            this.perDayLimitExceeded = false;
                            this.generateSchedulingTimeErrorMessage();
                        }
                        else if (this.schedulingOption !=='SCHEDULE' || payload.sendImmediately === true) {
                            this.perDayLimitExceeded = true;
                        }
                    } // check that body limit is not exceeded
                    else if(this.bodyLimitExceeded()) {
                        this.bodySizeLimitExceeded = true;
                    }
                    else {
                        this.perDayLimitExceeded = false;
                        this.perScheduledDayLimitExceeded = false;

                        this.recipientTags.forEach(function(recipientTag) {
                            switch(recipientTag.metaData.type) {
                                case this.CONTACT_TYPE:
                                    payload.recipients.push(recipientTag.metaData[this.CONTACT_TYPE]);
                                    break;
                                case this.MEDIA_LIST_TYPE:
                                    payload.mediaLists.push(recipientTag.metaData[this.MEDIA_LIST_TYPE]);
                                    break;
                                default:
                                    break;
                            }
                        }, this);

                        if(!payload.attachments && this.attachments.length > 0) {
                            payload.attachments = [];

                            this.attachments.forEach(function(attachment) {
                                payload.attachments.push({'size': attachment.size, 'fileLink': attachment.fileLink});
                            }.bind(this));
                        }

                        if(this.$routeParams.distributionId && this.$routeParams.state === undefined) {
                            payload.id = this.$routeParams.distributionId;

                            this.OutreachService.outreachUpdate(payload, this.fileUploadList).then(function() {
                                this.shouldSkipConfirmation = true;
                                this.closeCompose();
                            }.bind(this)).catch(function(error) {
                                if (error.statusCode === 409) {
                                    this.showProtectOverwriteModal(payload, error.error.reason);
                                }
                                else if (error.statusCode === 400 && error.error && error.error.reason === 'failedToSaveAttachments') {
                                    this.notifyAttachmentFailed(error.error.data.file);
                                }
                                else {
                                    this.showErrorMessage(this.genericErrorMsg);
                                }
                            }.bind(this));
                        } else {
                            this.OutreachService.outreach(payload, this.fileUploadList).then(function() {
                                this.shouldSkipConfirmation = true;
                                this.closeCompose();
                            }.bind(this)).catch(function(error) {
                                if (error.statusCode === 409) {
                                    this.showProtectOverwriteModal(payload, error.error.reason);
                                }
                                else if (error.statusCode === 400 && error.error && error.error.reason === 'failedToSaveAttachments') {
                                    this.notifyAttachmentFailed(error.error.data.file);
                                }
                                else if (error.statusCode === 500 && error.error && error.error.message === 'Mismatched Company on Approved Sender') {
                                    this.$mdDialog.show(
                                        this.$mdDialog.mwAlert()
                                            .title(this.translationService.getLocalizedString('icm-outreach__send-multi-company-warning-modal--header'))
                                            .htmlContent(this.translationService.getLocalizedString('icm-outreach__send-multi-company-warning-modal--body-string-1') + '<br><br>' + this.translationService.getLocalizedString('icm-outreach__send-multi-company-warning-modal--body-string-2'))
                                            .ok('OK')
                                    ).then(() => {
                                        this.status = 'Alert Closed';
                                    });
                                    this.disableSendNow = false;
                                }
                                else {
                                    this.disableSendNow = false;
                                    this.showErrorMessage(this.genericErrorMsg);
                                }
                            }.bind(this));
                        }
                        if (mailType) {
                            this.trackEvent(mailType, payload.recipients.length);
                        }
                    }
                }.bind(this)).catch(function() {
                    this.showErrorMessage(this.translationService.getLocalizedString('Fail to retrieve email history'));
                }.bind(this));

            this.ICMEmailService.resetRecipients();
        });
    };

    ContactManagerOutreachComposeController.prototype.showProtectOverwriteModal = function showProtectOverwriteModal(distribution, errorType) {
        this.$mdDialog.show({
            autoWrap: false,
            bindToController: true,
            fullscreen: false,
            locals: {
                distribution: distribution,
                disallowOverwrite: (errorType === 'outreachEmailSentConflict')
            },
            template: `<md-dialog id="protect-outreach-mini-modal" class="mw-mini-modal" aria-label="" layout="column">
                        <protect-edited-outreach class="mw-mini-modal-wrapper" distribution="$ctrl.distribution" disallow-overwrite="$ctrl.disallowOverwrite" layout="column"></protect-edited-outreach>
                    </md-dialog>`,
            // This is a globally available controller for the purposes of attaching locals for data binding
            controller: 'MwMiniModalDialogController',
            controllerAs: '$ctrl'
        }).then((data) => {
            if(data && data.option === 'copy') { // option === 'copy', allow to update the subject
                distribution.subject = data.subject;
                distribution.scheduledDate = null;
                this.OutreachService.outreach(distribution, this.fileUploadList).then(function() {
                    this.shouldSkipConfirmation = true;
                    this.closeCompose();
                }.bind(this)).catch(function() {
                    this.disableSendNow = false;
                    this.showErrorMessage(this.genericErrorMsg);
                }.bind(this));
            }
            else { // option === 'overwrite', does not allow to update anything
                distribution.ignoreConflict = true;
                this.OutreachService.outreachUpdate(distribution, this.fileUploadList).then(function() {
                    this.shouldSkipConfirmation = true;
                    this.closeCompose();
                }.bind(this)).catch(function() {
                    this.showErrorMessage(this.genericErrorMsg);
                }.bind(this));
            }
        },
        () => {
            //on cancel
            this.disableSendNow = false;
        });
    };

    ContactManagerOutreachComposeController.prototype.notifyAttachmentFailed = function notifyAttachmentFailed(attachment) {
        if(!this.dialogMode && this.attachmentError.errorState === false) {
            this.disableSendNow = false;

            // remove attachment from the upload list
            if (attachment) {
                var index = this.fileUploadList.findIndex(function(file) {
                    return file.name === attachment.name;
                });

                if (index !== -1) {
                    this.removeAttachedFile(attachment, index);
                }
            }

            // open alert banner
            this.OutreachBannerService.openAttachmentAlertBanner({
                attachTo: '.banner-space'
            });
        }
    };

    /**
     * @description Method to invoke and handle confirmation to leave compose email page
     *
     * @param {}
     */
    ContactManagerOutreachComposeController.prototype.confirmCloseCompose = function confirmCloseCompose() {
        var dialogTitle,
            dialogContent,
            dialogOptions,
            payload,
            defer = this.$q.defer();

        if(this.schedulingOption !== 'SAVE_DRAFT' && this.isValidComposeForm()) {
            dialogTitle = this.translationService.getLocalizedString('Save changes?');
            dialogContent = this.translationService.getLocalizedString('Do you want to save the changes you\'ve made to this scheduled email before you close?');
        } else {
            this.schedulingOption = 'SAVE_DRAFT';
            dialogTitle = this.translationService.getLocalizedString('Save draft?');
            dialogContent = this.translationService.getLocalizedString('Do you want to save this email before you close?');
        }

        dialogOptions = {
            title: dialogTitle,
            customDialogCss: {
                executeBefore: {
                    left: '50%'
                }
            }
        };
        payload = {
            content: dialogContent
        };

        if(!this.formHolder.composeForm.$dirty) {
            this.closeCompose();
            defer.resolve();
            return defer.promise;
        }

        dialogOptions.callbackOnCancel = function callbackOnCancel() {
            defer.reject();
        };

        this.DialogService.confirmExit(dialogOptions, payload, function confirmLeavePageCallback(response) {
            if(response.successDetail === 'abandon') {
                this.closeCompose();
            } else {
                this.saveMail();
            }
            defer.resolve();
        }.bind(this));

        return defer.promise;
    };

    /**
     * @description Method to handle closing compose email page
     *
     * @param {boolean} waitToConfirm to confirm (confirmation box will appear)
     */
    ContactManagerOutreachComposeController.prototype.closeCompose = function closeCompose(waitToConfirm) {
        this.ICMEmailService.resetRecipients();

        if(waitToConfirm) {
            this.confirmCloseCompose();
        } else {
            if(this.dialogMode) {
                this.DialogService.closeDialog();
            } else {
                //Hide animation before moving to next page
                angular.element('.composeEmailContainer').addClass('hideContainer');

                //Let the animation complete for 0.5 seconds
                this.$timeout(function() {
                    //if opened compose in a new tab, return to landing page on close
                    //if opened from landing page, return to outreach page on close
                    // else navigate back to where compose was opened. this logic was done because the compose page is not a modal
                    if(this.previousPage && this.previousPage.includes('/influencers/contact/outreach')) { // redirect to outreach landing page
                        window.location.href =  `${this.ICM_BASE_URL}/influencers/contact/outreach`;
                    } else if(history.length === 1 || (history.length === 2 && window.location.href.includes('step=2'))) { //if open in a new tab, redirect to MR landing page
                        window.location.href = this.IRM_BASE_URL;
                    } else {
                        if(this.$routeParams.contact) {
                            window.location.href = `${this.IRM_BASE_URL}/contact/${this.$routeParams.contact}?view=interactions`;
                        } else if(window.location.href.includes('step=2')){
                            history.go(-2);
                        } else {
                            history.back();
                        }
                    }
                }.bind(this), 500);
            }
        }
    };

    /**
     * @description Handle attachment of a file to email
     *              Validations for the sameincluded
     *
     * @param {}
     */
    ContactManagerOutreachComposeController.prototype.onFileAttachmentAdd = function onFileAttachmentAdd() {
        var validateFileType,
            sanitizeFileObject,
            fullFileObject,
            foundInvalidUpload = false;

        this.attachmentError = {
            errorState: false,
            invalidFileType: false,
            zeroFileSize: false,
            invalidFileSize: false,
            invalidTotalFileSize: false
        };

        validateFileType = function validateFileType(fileType) {
            if(this.validFileTypes.indexOf(fileType) > -1) {
                return fileType;
            } else {
                this.attachmentError.errorState = this.attachmentError.invalidFileType = true;
                return 'invalid file type';
            }
        }.bind(this);

        sanitizeFileObject = function sanitizeFileObject(fileObject) {
            var displayFileName,
                displayFileSize,
                displayFileExt;

            displayFileSize = this.validateFileSize(fileObject.size);
            displayFileExt = fileObject.name.lastIndexOf('.') > -1 ? validateFileType(fileObject.name.substr(fileObject.name.lastIndexOf('.')).toUpperCase()) : validateFileType();

            if(!displayFileSize || displayFileExt === 'invalid file type') {
                return false;
            }

            this.totalFileAttachedSize += fileObject.size;
            displayFileName = fileObject.name.substr(0, fileObject.name.lastIndexOf('.'));

            fileObject.displayFileName = decodeURIComponent(displayFileName);
            fileObject.displayFileExt = displayFileExt;
            fileObject.displayFileSize = displayFileSize;

            return fileObject;
        }.bind(this);
        this.$timeout(function() {
            if(this.attachment.length) {
                angular.forEach(this.attachment, function(fileObject){
                    fullFileObject = sanitizeFileObject(fileObject);
                    if(fullFileObject) {
                        this.$scope.$apply(function(){
                            this.fileUploadList.push(fileObject);
                        }.bind(this));
                    } else {
                        foundInvalidUpload = true;
                    }
                }.bind(this));
                if(foundInvalidUpload) {
                    this.$scope.$apply();
                }
            }
        }.bind(this), 0);

        this.setFormDirty();
    };

    /**
     * @description Handling removal of an attached file
     *
     * @param {object} fileObject
     *        {index number} index position of file in array
     */
    ContactManagerOutreachComposeController.prototype.removeAttachedFile = function removeAttachedFile(fileObject, index) {
        this.fileUploadList.splice(index, 1);
        this.totalFileAttachedSize -= fileObject.size;
        this.attachmentError = {
            errorState: false,
            invalidFileType: false,
            zeroFileSize: false,
            invalidFileSize: false,
            invalidTotalFileSize: false
        };

        this.setFormDirty();
    };

    /**
     * @description Handling removal of attachment during update flow
     *
     * @param {object} fileObject
     *        {index number} index position of file in array
     */
    ContactManagerOutreachComposeController.prototype.removeAttachment = function removeAttachment(fileObject, index) {
        this.attachments.splice(index, 1);
        this.totalFileAttachedSize -= fileObject.size;
        this.attachmentError = {
            errorState: false,
            invalidFileType: false,
            zeroFileSize: false,
            invalidFileSize: false,
            invalidTotalFileSize: false
        };

        this.setFormDirty();
    };

    /**
     * @description checks for validation of compose form
     *
     * @param {}
     * @returns {boolean}
     */
    ContactManagerOutreachComposeController.prototype.isValidComposeForm = function isValidComposeForm() {
        var isValid;
        if(this.schedulingOption === 'SCHEDULE'){
            isValid = !!(this.recipientTags.length && this.subject && this.messageBodyText && this.totalRecipientCount <= this.recipientsPerDistributionLimit && !this.perDayLimitExceeded && !this.perScheduledDayLimitExceeded && !this.bodyLimitExceeded() && this.indexOfObject(this.approvedSendersListDropDown, this.selectedApprovedSender) > -1);
        } else {
            isValid = !!(this.recipientTags.length && this.subject && this.messageBodyText && this.totalRecipientCount <= this.recipientsPerDistributionLimit && !this.perDayLimitExceeded && !this.bodyLimitExceeded() && this.indexOfObject(this.approvedSendersListDropDown, this.selectedApprovedSender) > -1);
        }
        return isValid;
    };

    /**
     * @description checks for validation of recipients field
     *
     * @param {}
     * @returns {boolean}
     */
    ContactManagerOutreachComposeController.prototype.isValidRecipientsField = function isValidRecipientsField(){
        return !!(this.totalRecipientCount <= this.recipientsPerDistributionLimit && !this.perDayLimitExceeded );
    };

    /**
     * @description validates file size
     *
     * @param {Number} fileSize in Bytes.
     * @returns {Boolean}
     */
    ContactManagerOutreachComposeController.prototype.validateFileSize = function validateFileSize(fileSize) {
        var displayFileSize = '',
            mb = ' ' + this.translationService.getLocalizedString('MB'),
            kb = ' ' + this.translationService.getLocalizedString('KB'),
            bytes = ' ' + this.translationService.getLocalizedString('Bytes');

        if((this.totalFileAttachedSize + fileSize) > this.totalFileSizeLimit) {
            this.attachmentError.errorState = true;
            if((this.totalFileAttachedSize + fileSize) > this.totalFileSizeLimit) {
                this.attachmentError.invalidTotalFileSize = true;
            }
            return false;
        }
        else if (parseInt(fileSize) === 0) {
            this.attachmentError.errorState = true;
            this.attachmentError.zeroFileSize = true;
            return false;
        }

        if (fileSize >= (1024*1024)) {
            displayFileSize = (fileSize / (1024*1024)).toFixed(2) + mb;
        }
        else {
            if(fileSize > 1024) {
                displayFileSize += (fileSize/1024).toFixed(2) + kb;
            }
            else {
                displayFileSize += (fileSize + bytes);
            }
        }

        return displayFileSize;
    };

    /**
     * @description called when approved sender selected from dropdown is changed
     *
     * @param approvedSenderObj
     * @returns {}
     */
    ContactManagerOutreachComposeController.prototype.approvedSenderChanged = function approvedSenderChanged() {
        this.setFormDirty();
        this.closeDialogInlineMessages();
    };

    /**
     * @description sets the form state as $dirty
     *
     * @param {}
     * @returns {}
     */
    ContactManagerOutreachComposeController.prototype.setFormDirty = function setFormDirty() {
        if(!this.formHolder.composeForm.$dirty) {
            this.formHolder.composeForm.$setDirty();
        }
    };

    /**
     * @description Checking for unsubscribed contacts
     *
     * @param [array] contactsEmailArray Email Array
     * @returns promise
     */
    ContactManagerOutreachComposeController.prototype.checkForUnsubscribedContacts = function checkForUnsubscribedContacts(contactsEmailArray) {
        contactsEmailArray = contactsEmailArray.filter(function(e){
            return e;
        });

        return this.UnsubscribeService.unsubscribedContactStatus(contactsEmailArray);
    };

    /**
     * @description adding contacts to recipients array
     *
     * @param {object} contact object
     * @param {object} unsubscribed email object
     */
    ContactManagerOutreachComposeController.prototype.addTagToRecipients = function addTagToRecipients(contact, unsubscribedObject) {
        var result = unsubscribedObject[contact.email.trim().toLowerCase()],
            tagStyleProp = contact.id && contact.id !== null ? '' : this.manualEmailTagStyle;

        contact.title = result ? contact.email : this.translationService.getLocalizedString('Contact unsubscribed. Email will not be sent.');

        if(this.recipientTags){
            for(var i=0; i<this.recipientTags.length; i++) {
                if(contact.email === this.recipientTags[i].trackBy) {
                    this.recipientTags[i].title = contact.title;
                }
            }
        }

        if(this.shouldAddTag(contact.email)) {
            // tag contact
            this.recipientTags.push({
                class: tagStyleProp,
                display: contact.name || contact.email,
                icon: this.contactIcon,
                title: contact.title,
                trackBy: contact.email,
                metaData: {
                    type: this.CONTACT_TYPE,
                    contact: contact,
                    private: contact.private
                }
            });

            // update counts
            this.totalRecipientCount = this.getDedupCountOfRecipientEmails();
        }
    };

    ContactManagerOutreachComposeController.prototype.openMediaListDialog = function openMediaListDialog() {
       this.ContactManagerTagService.addToComposeMediaListsDialog(this.mediaListArray,this.preSelectedMediaLists,this.recipientsLabel,function dialogSuccessCallBack(selectedMediaListsArray, removedMediaLists) {
            for(var i=0; i<this.recipientTags.length; i++)
             {
                 if(this.recipientTags[i].metaData.mediaList) {
                    if(removedMediaLists[this.recipientTags[i].metaData.mediaList.id])
                    {
                        this.onTagRemoved(this.recipientTags[i]);
                        this.recipientTags.splice(i--, 1);
                    }
                 }
            }
            for(var j=0; j<selectedMediaListsArray.length; j++){
                this.addMediaListToRecipients(selectedMediaListsArray[j]);
            }
        }.bind(this));
    };

    ContactManagerOutreachComposeController.prototype.updateEditorBusy = function updateEditorBusy(isBusy) {
        this.disableSendNow = isBusy;

        this.$timeout(function applyChanges() {
            this.$scope.$apply();
        }.bind(this), 0);
    };

    ContactManagerOutreachComposeController.prototype.trackEvent = function trackEvent(type, recepientCount) {
        var promises = [],
            currentUser,
            currentCompany,
            trackingData;

        promises.push(this.CoreUserService.getCurrent(true));
        promises.push(this.CoreCompanyService.getCurrent(true));

        this.$q.all(promises).then(function(responses) {
            currentUser = responses[0];
            currentCompany = responses[1];
            trackingData = {
                source: 'webapp',
                label: 'outreach_email',
                contactCount: recepientCount,
                parentType: 'email',
                subType: type,
                userId: currentUser.email + ' (' + currentUser._id + ') ' + currentCompany.name
            };
            this.AnalyticsService.trackMediaListOperation('outreach_email', trackingData);

        }.bind(this));
    };

    ContactManagerOutreachComposeController.prototype._convert24hourTo12hourTime = function _convert24hourTo12hourTime(twentyFourHourString) {
        twentyFourHourString = twentyFourHourString.toString();

        var hourMinuteArray = twentyFourHourString.split(':'),
            hour = hourMinuteArray[0],
            minute = hourMinuteArray[1],
            twentyFourHourTimeObject = {
                hour: null,
                minute: minute,
                amPm: null
            };

        if(!twentyFourHourString.match(/..:../)) {
            throw ('invalid twenty four hour format');
        }

        if((hour < 0) || (hour > 23)) {
            throw ('invalid hour');
        }

        if((minute < 0) || (minute > 59)) {
            throw ('invalid minute');
        }

        if(hour === '00') {
            twentyFourHourTimeObject.hour = '12';
            twentyFourHourTimeObject.amPm = 'AM';
        } else if(hour === '12') {
            twentyFourHourTimeObject.hour = '12';
            twentyFourHourTimeObject.amPm = 'PM';
        } else {
            if(hour < 12) {
                twentyFourHourTimeObject.hour = hour;
                twentyFourHourTimeObject.amPm = 'AM';
            } else {
                twentyFourHourTimeObject.hour = (hour - 12).toString();
                twentyFourHourTimeObject.amPm = 'PM';
            }
        }

        twentyFourHourTimeObject.hour = twentyFourHourTimeObject.hour.padStart(2, '0');
        return twentyFourHourTimeObject;
    };

    ContactManagerOutreachComposeController.prototype._convert12hourTo24hour = function _convert12hourTo24hour(hour, amPm) {
        hour = parseInt(hour);
        amPm = amPm.toString().toUpperCase();

        var twentyFourHourString;

        if((hour < 0) || (hour > 12) || isNaN(hour)) {
            throw ('invalid hour');
        }

        if((amPm !== 'AM') && (amPm !== 'PM')) {
            throw ('invalid meridiem');
        }

        if(hour === 12) {
            twentyFourHourString = ((amPm === 'AM') ? '00' : '12');
        } else {
            twentyFourHourString = ((amPm === 'AM') ? hour.toString() : (hour + 12).toString());
        }

        twentyFourHourString = twentyFourHourString.padStart(2, '0');
        return twentyFourHourString;
    };

    ContactManagerOutreachComposeController.prototype.setScheduledDate = function() {
        let hour = parseInt(this.hour),
            minute = this.minute.toString(),
            timeString = (this._convert12hourTo24hour(hour, this.meridiem) + ':' + minute),
            utcString = this._convertDateTimeStringToUtc(this.scheduledDateModel, timeString);
        if(this.moment(utcString).isAfter(this.moment())) {
            return utcString;
        } else {
            this.schedulingTimeError = true;
        }
    };

    ContactManagerOutreachComposeController.prototype.adjustDateToEndOfDay = function adjustDateToEndOfDay(date) {
        let rightNow = this.moment.tz(date, this.ICMUserService.getTimezone()),
            endOfDayToday = rightNow.clone().endOf('day').utc();

        return endOfDayToday;
    };

    ContactManagerOutreachComposeController.prototype.getTotalHoursBetweenDates = function getTotalHoursBetweenDates(now, later) {
        let rightNow = this.moment.tz(now, this.ICMUserService.getTimezone());
        return Math.ceil(this.moment.duration(later.diff(rightNow)).asHours());
    };

}());